import { Mixpanel } from "hooks/mixPanel";
import { useAppSelector } from "state/hooks";
import { getGroupState } from "state/slices/group-slice.ts";

interface Props {
  styles?: object;
}

const AdBannerView = ({ styles = {} }: Props) => {
  const contestBannerState = useAppSelector((state) => state.adContest);
  const groupBanner = useAppSelector(getGroupState).settings?.ad_banner;

  const activeBanner = contestBannerState.contestBanner?.enabled
    ? contestBannerState.contestBanner
    : groupBanner?.enabled ? groupBanner : null;

  if (!activeBanner) {
    return <></>;
  }

  return (
    <div
      style={{
        height: "50%",
        alignItems: "center",
        display: "flex",
        ...styles,
      }}
    >
      <a
        onClick={() => {
          Mixpanel.track("Ad Banner Clicked", {
            imageUrl: activeBanner.image_url,
            link: activeBanner.link_url,
            isContestBanner: activeBanner === contestBannerState.contestBanner
          });
        }}
        rel="noreferrer"
        href={activeBanner.link_url}
        target="_blank"
      >
        <img width="100%" src={activeBanner.image_url} alt={""} />
      </a>
    </div>
  );
};

export default AdBannerView;
